import * as Yup from 'yup'

export const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('email is invalid*')
    .matches(/^[^$%`~|\/]+$/, 'Invalid email format')
    .required('required*')
})
